<template>
  <div v-if="question">
    <div class="row">
      <div :class="question.picture !== null ? 'col-md-9' : 'col-md-12'">
        <div>
          <label>Overview</label>
          <div>
            <template v-if="question.company_profile">{{question.company_profile}}</template>
            <template>{{question.objective}}</template> <br>
            <template v-if="question.issue">{{question.issue}}</template>
            <template v-if="question.restraint">{{question.restraint}}</template>
            <template v-if="question.expert_interest"><br>{{question.expert_interest}}</template>
          </div>
        </div>
      </div>
      <div v-if="question.picture" class="col-md-3">
        <img :src="$apiUrl + question.picture" style="max-width: 100%"/>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <label>Details</label>
        <div v-html="question.long_description"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12" v-if="question.files.length !== 0">
        <label>Files</label>
        <div>
          <a v-for="(file, key) in question.files" :key="key" :href="api_url + file.filename" target="_blank" class="col-xs-3">{{file.filename.replace(/^.*[\\\/]/, '')}}</a>
        </div>
      </div>
    </div>

    <div class="row" style="margin-top: 15px">
      <div class="col-md-6">
        <div>
          <label>Maturity level</label>
          <div v-if="question.trl">{{question.trl.name}}</div>

        </div>

        <div style="margin-top: 15px">
          <label>Timeline</label>
          <div v-if="question.timeline">{{question.timeline.name}}</div>

        </div>

        <div style="margin-top: 15px">
          <label>Intellectual Property Rights</label>
          <div v-for="(maturity, key) in question.maturities" :key="key">{{maturity.name}}</div>

        </div>

        <div style="margin-top: 15px">
          <label>Expected proposal</label>
          <div v-for="(proposalRequest, key) in question.proposal_requests" :key="key">{{proposalRequest.label}}</div>
        </div>
      </div>

      <div class="col-md-6" v-if="question.metrics.length">
        <label>Measurable performance</label>
        <table cellpadding="1" cellspacing="1" class="table table-condensed table-striped">
          <thead>
          <tr>
            <th>Criteria</th>
            <th>Common figure (SoA)</th>
            <th>Target</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(metric, key) in question.metrics" :key="key">
            <td>{{metric.name}}</td>
            <td>{{metric.current}}</td>
            <td>{{metric.target}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row" style="margin-top: 15px">
      <div class="col-xs-12">
        <label>Additional information</label>
        <div class="row">
          <div class="col-md-4" v-if="question.nb_response">
            <label>Nb response would like</label>
            <div>{{question.nb_response.name}}</div>
          </div>
          <div class="col-md-4" v-if="question.nb_response">
            <label>Pre-set-reward</label>
            <div>{{question.reward_descr}}</div>
          </div>
          <div class="col-md-4" v-if="question.keywords">
            <label>Keywords</label>
            <div>{{question.keywords}}</div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>

export default {
  components: {},
  name: 'QuestionReport',
  props: ['question'],
  data () {
    return {
      api_url: process.env.API_URL
    }
  },
  mounted () {
    this.$emit('resourcesLoaded', true)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/question/Report.vue